import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import type { Address } from '@models/address.ts';
import { Requests } from '@tools/requests';
import { flashBagError } from '../flashbag';
import { URL_XHR_ADDRESSES_FAVORITE } from '../routes/routes';

export const useFavoriteAddressesStore = defineStore('favoriteAddresses', () => {
  const addressesIds = ref<number[]>(window.initialFavoriteAddressesIds ?? []);

  const isSaving = ref<boolean>(false);
  const wasRecentlySaved = ref<boolean>(false);

  const addressesIdsAsString = computed<string>(() => addressesIds.value.map((id: number) => id).join(','));

  const saveAddresses = async (addresses: Address[]): Promise<void> => {
    isSaving.value = true;
    addressesIds.value = addresses.map((address) => address.id);
    try {
      await Requests.post(URL_XHR_ADDRESSES_FAVORITE, { addresses: addressesIdsAsString.value });
      wasRecentlySaved.value = true;
      setTimeout(() => {
        wasRecentlySaved.value = false;
      }, 3000);
    } catch (error) {
      flashBagError();
    }
    isSaving.value = false;
  };

  return {
    addressesIds,
    saveAddresses,
    isSaving,
    wasRecentlySaved,
  };
});
